import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { TabsModule } from 'primeng/tabs';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { PasswordModule } from 'primeng/password';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
@NgModule({
  exports: [
    ButtonModule,
    InputTextModule,
    SelectModule,
    RadioButtonModule,
    ToggleButtonModule,
    TooltipModule,
    ToastModule,
    TabsModule,
    TableModule,
    PaginatorModule,
    CheckboxModule,
    DialogModule,
    MenuModule,
    PasswordModule,
    SelectButtonModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule,
    InputSwitchModule,
    IconFieldModule,
    InputIconModule,
  ],
})
export class PrimeNgModule {}
